/** @format */

import { IconButton, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/button';

interface ContentEditorErrorDialogProps {
  open: boolean;
  message?: string;
  onClose: () => void;
}

export default function ContentEditorErrorDialog({ open, message = '', onClose }: ContentEditorErrorDialogProps) {
  const { t, i18n } = useTranslation();
  const displayMessage = !message
    ? t('common.unknownError')
    : i18n.exists(message)
      ? t(message)
      : message;

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      PaperProps={{
        style: {
          backgroundColor: '#fff'
        }
      }}
      onClose={onClose}
      aria-labelledby="content-editor-error-dialog-title">
      <DialogActions>
        <IconButton onClick={onClose} aria-label={t('common.button.close')}>
          <CloseIcon style={{ color: '#000' }} />
        </IconButton>
      </DialogActions>
      <DialogContent>
        <div className="content-editor__error-dialog">
          <HighlightOffIcon
            className="content-editor__error-dialog-icon"
            aria-hidden
          />
          <Typography
            component="h2"
            className="content-editor__error-dialog-title"
            id="content-editor-error-dialog-title">
            {t('contentEditor.errorDialogTitle')}
          </Typography>
          <Typography className="content-editor__error-dialog-message">{displayMessage}</Typography>
          <div className="content-editor__error-dialog-actions">
            <Button secondary onClick={onClose} label={t('common.button.close')} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
